
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

/**
 * Fetch mentor profile data
 */
export const fetchMentorProfile = async (mentorId: string) => {
  const { data, error } = await supabase
    .from('user_profiles')
    .select('id, first_name, last_name, profile_photo_url')
    .eq('id', mentorId)
    .single();
  
  if (error) {
    console.error('Error fetching mentor profile:', error);
    return null;
  }
  
  // Format the mentor name
  return {
    ...data,
    name: data ? `${data.first_name || ''} ${data.last_name || ''}`.trim() || 'Unknown' : 'Unknown'
  };
};

/**
 * Fetch attendees for a session
 */
export const fetchSessionAttendees = async (sessionId: string) => {
  const { data, error } = await supabase
    .from('office_hours_attendees')
    .select('*')
    .eq('office_hours_id', sessionId);
  
  if (error) {
    console.error('Error fetching session attendees:', error);
    return [];
  }
  
  return data;
};

/**
 * Fetch user profiles for attendees
 */
export const fetchAttendeeProfiles = async (attendees: any[]) => {
  return Promise.all(
    attendees.map(async (attendee) => {
      const { data: userData, error: userError } = await supabase
        .from('user_profiles')
        .select('first_name, last_name, profile_photo_url')
        .eq('id', attendee.user_id)
        .single();
      
      return {
        ...attendee,
        user: userError ? null : userData
      };
    })
  );
};
